import { TableCellProps } from "../../../../types";
import { getWidth } from "../../utils";
import TableCellLoader from "../TableCellLoader";

export const alignItemPositions = {
  center: "center",
  left: "flex-start",
  right: "flex-end",
};

function TableCell({
  rowData,
  stickyClass = "",
  enableRowDrag,
  onRowDragStart,
  onRowDragOver,
  onRowDrop,
  allowRowExpansion,
  handleRowToggle,
  columnData,
  index,
  expandedRows,
  loading,
  rowLevel = 0,
  showExpansionIcon = false,
  rowKey,
}: TableCellProps) {
  return loading ? (
    <div
      key={columnData.field}
      className={`div-grid-cell ${stickyClass}`}
      style={{
        ...(columnData.field === "selection" && stickyClass === "sticky-left"
          ? { minWidth: columnData.width, width: columnData.width }
          : getWidth(columnData.width)),
        paddingLeft:
          stickyClass === "sticky-left" &&
          rowData._level &&
          rowData._level !== 0 &&
          showExpansionIcon
            ? `${rowData._level * 30}px`
            : "15px",
      }}
    >
      {columnData?.skeleton ? columnData?.skeleton : <TableCellLoader />}
    </div>
  ) : (
    <div
      key={columnData.field}
      className={`div-grid-cell ${stickyClass}`}
      style={{
        ...(columnData.field === "selection" && stickyClass === "sticky-left"
          ? { minWidth: columnData.width, width: columnData.width }
          : getWidth(columnData.width)),
        paddingLeft:
          stickyClass === "sticky-left" &&
          rowData._level &&
          rowData._level !== 0 &&
          showExpansionIcon
            ? `${rowData._level * 30}px`
            : "15px",
        justifyContent: columnData?.alignItem
          ? alignItemPositions[columnData?.alignItem]
          : "left",
      }}
      draggable={enableRowDrag}
      onDragStart={() => onRowDragStart(index)}
      onDragOver={(e) => onRowDragOver(index, e)}
      onDrop={() => onRowDrop(index)}
      onClick={() => {
        if (
          (rowData.children || allowRowExpansion) &&
          stickyClass === "sticky-left" &&
          showExpansionIcon
        ) {
          handleRowToggle(rowData);
        }
      }}
    >
      {(rowData.children || (allowRowExpansion && rowLevel === 0)) &&
      stickyClass === "sticky-left" &&
      showExpansionIcon ? (
        <span className="expand-toggle">
          {expandedRows.has(rowData?.[rowKey]) ? "▼" : "▶"}
        </span>
      ) : null}
      {columnData.body ? (
        columnData.body(rowData, columnData.field, rowData?._level)
      ) : rowData[columnData.field] !== undefined ? (
        typeof rowData[columnData.field] === "string" ? (
          <span>{rowData[columnData.field]}</span>
        ) : (
          rowData[columnData.field]
        )
      ) : (
        rowData[columnData.field]
      )}
    </div>
  );
}

export default TableCell;
